import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	isMmcAdmin: false,
	isMmcUser: false,
	resultList: [],
	ubiTarget: '',
	searchParams: SEARCH_PARAMS(),
	pagingInfo: POPUP_PAGING_INFO(),
	popupData: POPUP_DATA(),

	hisResultList1: [],
	hisPagingInfo1: POPUP_PAGING_INFO(),

	hisResultList2: [],
	hisPagingInfo2: POPUP_PAGING_INFO(),

	eqipDtlCdList: [], //장비 selectBox
	eqipKndCdList: [], //장비종류 selectBox
	calInstCdList: [], //교정업체 selectBox
	calStCdList: [], //교정상태 selectBox
	runStCdList: [], //가동상태 selectBox
	calWayCdList: [], //교정방식 selectBox
	calCyclCdList: [], //교정주기 selectBox
	calRsltCdList: [], //교정결과 selectBox
	runStCdList: [], //가동상태 selectBox
	ynCdList: [], //보고서유무 selectBox
	usePlCdList: [], //사용장소 selectBox
	sndStCdList: [], //메일 발송상태 selectBox
	utmCdList: [], //측정단위 selectBox

	// 사용자 공통팝업 파라미터 정보
	searchUserPopParams: SEARCH_USER_POPUP_PARAMS()
};

function SEARCH_PARAMS() {
	return {
		mesEqipNo: '',
		mesEqipNm: '',
		calStCd: '', //교정상태
		runStCd: '', //가동상태
		userId: '', // 담당자id
		userName: '', //담당자명
		strDt: startDt,
		endDt: endDt,
		sndStCd:''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function POPUP_PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function POPUP_DATA() {
	return {
		mesEqipNo: '', //측정기관리번호
		mesEqipNm: '', //장비명
		koMesEqipNm: '', //한글측정기명
		enMesEqipNm: '', //영문측정기명
		chMesEqipNm: '', //중문측정기명
		puchDd: '', //구입일자
		mkrNm: '', //제조사명
		mdlNm: '', //모델명
		eqipSn: '', //장비일련번호
		eqipKndCd: '', //장비종류코드
		eqipDtlCd: '', //장비상세코드
		useDeptCd: '', //사용부서코드
		useDeptNm: '', //사용부서명칭
		usePlCd: '', //사용장소코드
		user1Id: '', //사용자_정ID (담당자)
		user1Nm: '', //사용자_정명
		user2Id: '', //사용자_부ID (부서장)
		user2Nm: '', //사용자_부명
		mesScpMinVal: '', //측정범위최소값
		mesScpMaxVal: '', //측정범위최대값
		mesUtmCd: '-', //측정범위단위코드
		lodeMinVal: '', //정밀도최소값
		lodeMaxVal: '', //정밀도최대값
		spcVal: '', //사양값
		lodeUtmCd: '-', //정밀도단위코드
		calInstCd: '', //교정기관코드
		calWayCd: 'OSCP', //교정방식코드
		calCyclCd: '', //교정주기코드
		calExp: '', //교정비용
		whsnDt: '', //입고일시
		pvoDd: '', //불출일시
		nextCalDd: '', //차기교정일
		calCmplDd: '', //교정완료일
		runStCd: 'NORM', //가동상태코드
		calStCd: '', //교정상태코드
		calWrptYn: '', //교정보고서유무
		rslrNo: '', //성적서번호
		rslrFileId: '', //성적서파일ID
		calRsltCd: '', //교정결과코드
		calSbc: '', //교정내용
		rmk: '' ,//비고
		sndStCd:''
	};
}

//사용자 조회 팝업
function SEARCH_USER_POPUP_PARAMS() {
	return {
		userName: '',
		userId: ''
	};
}
export { SEARCH_PARAMS, PAGING_INFO, POPUP_DATA, POPUP_PAGING_INFO, SEARCH_USER_POPUP_PARAMS };
